var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 2.167a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm-.833 10L9.417 5.5h2.5l-.416 6.667H9.834Zm.833 4.166a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimited);
export default __webpack_public_path__ + "static/media/limited.ca8ded4faed6f29fdf7e5fda1ba71fe8.svg";
export { ForwardRef as ReactComponent };